import { withErrorContext } from ".";
import { isHotkey } from "is-hotkey";
import { Editor } from "slate";

import { BLOCK_FORMATS, LIST_FORMATS, isBlockActive } from "./richText";

/* eslint-disable no-param-reassign */
export function withBlockSoftBreaks(editor: Editor): Editor {
  return editor;
}
/* eslint-enable no-param-reassign */

function handleReturnRules(event: React.KeyboardEvent<HTMLDivElement>, editor: Editor): boolean {
  const isBlockFormat = BLOCK_FORMATS.some(format => isBlockActive(editor, format));

  const isList = LIST_FORMATS.some(format => isBlockActive(editor, format));

  if (isList) {
    if (event.shiftKey) {
      event.preventDefault();
      editor.insertText("\n");
      return true;
    }
  } else if (isBlockFormat) {
    if (!event.shiftKey) {
      event.preventDefault();
      editor.insertText("\n");
      return true;
    }
  }

  return false;
}

export const ReactPart: import("./index").ReactPart = {
  onKeyDown(
    event: React.KeyboardEvent<HTMLDivElement>,
    editor: Editor,
    next: (event: React.KeyboardEvent<HTMLDivElement>) => void
  ): void {
    if (isHotkey("shift?+return", event.nativeEvent)) {
      const handled = handleReturnRules(event, editor);
      if (!handled) {
        next(event);
      }
    } else {
      next(event);
    }
  },
};

const pluginSpec: import("./index").PluginSpec = [withErrorContext(withBlockSoftBreaks), ReactPart];
export default pluginSpec;
